import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-customer-select-item',
  templateUrl: './customer-item.component.html',
  styles: [],
  standalone: false
})
export class CustomerSelectItemComponent {
  @Input() customer: any = {};

  color: { [key: number]: string } = {
    0: '#87d068',
    1: '#f25f12',
    2: '#f50',
    3: '#2db7f5'
  };
  status: { [key: number]: string } = {
    0: 'ACTIVE',
    1: 'INACTIVE',
    2: 'PROSPECT',
    3: 'SUSPENDED'
  };
  constructor() {}
}
